<template>
<div id="home">
<section 
     class="w3-animate city-jumbo header1 cid-qwYE4H2V83 mbr-parallax-background" id="header1-4" data-rv-view="352" data-jarallax-original-styles="null">

    <div class="city-margin">
    </div>

    <div id="jumbo" class="container">
        <div class="row justify-content-md-center">
            <div class="mbr-white col-md-10">
                <div class="height-dp"></div>
                <h1 class="city-title mbr-section-title align-center mbr-bold mbr-fonts-style ">
                {{ title }}</h1>
                <h2 class="city-sub align-center mbr-light mbr-fonts-style display-8 ">
                {{ subheading }}</h2>
            </div>
            <div class="mbr-white col-md-10">
                <div class="mbr-section-btn align-center">
                    <a class="btn btn-md btn-white display-4 " v-bind:href="link1Html">
                    {{ link1Title }}   
                    </a> 
                    <a class="btn btn-md btn-success display-4 " v-bind:href="link2Html">
                    {{ link2Title }}
                    </a>
                </div>
            </div>
        </div>
    </div>


    <div id="utf-hero">
    </div>

    <div class="remove-arrow">
        <div class="align-center">
            <p class="city-next"><a class="city-grey " href="#section2">
            NEXT</a></p>
            <a class="next-grey" href="#section2">
                <img class="arrow-img" src="../index_files/images/arrow.svg" alt="Next Arrow Down">
            </a>
        </div>
    </div>
</section>

<div id="section2" class="city-pt7em"></div>


<section class="city-flex features1 cid-qwYHOWvXyr mbr-parallax-background" id="features1-6" data-rv-view="355" data-jarallax-original-styles="null">
    
    <div></div>
    <div class="container">
        <div class="media-container-row" id="flexfirst">

            <!-- Flex 1 -->
            <div class="card p-3 col-12 col-md-6 col-lg-4">
                <div class="pb-3 text-center">
                    <span class="city-flex-font-color svg-7em"></span>
                    <img src="../index_files/images/map.svg" class="svg-7em" alt="Map Icon">
                </div>
                <div class="card-box text-center">
                    <h3 class="white-font card-title py-3 mbr-fonts-style display-5 ">
                        {{ box1Title }}</h3>
                    <div class="d-flex p-2 justify-content-center"><div class="small-city-green-div"></div></div>
                    <p class="white-font mbr-fonts-style display-7 ">
                        {{ box1Detail }}
                    </p>
                    <a class="btn btn-sm btn-white display-4 " v-bind:href="box1Link">
                        {{ box1Button }}  
                    </a> 
                </div>
            </div>

            <!-- Flex 2 -->
            <div class="card p-3 col-12 col-md-6 col-lg-4">
                <div class="pb-3 text-center">
                    <span class="city-flex-font-color svg-7em"></span>
                    <img src="../index_files/images/money.svg" class="svg-7em" alt="Money Icon">
                </div>
                <div class="card-box text-center">
                    <h3 class="white-font card-title py-3 mbr-fonts-style display-5 ">
                        {{ box2Title }}</h3>
                    <div class="d-flex p-2 justify-content-center"><div class="small-city-green-div"></div></div>
                    <p class="white-font mbr-fonts-style display-7 ">
                        {{ box2Detail }}
                    </p>
                    <a class="btn btn-sm btn-white display-4 " v-bind:href="box2Link">
                        {{ box2Button }}    
                    </a> 
                </div>
            </div>

            <!-- Flex 3 -->
            <div class="card p-3 col-12 col-md-6 col-lg-4">
                <div class="pb-3 text-center">
                    <span class="city-flex-font-color svg-7em"></span>
                    <img src="../index_files/images/help.svg" class="svg-7em" alt="Helping Hands Icon">
                </div>
                <div class="card-box text-center">
                    <h3 class="white-font card-title py-3 mbr-fonts-style display-5 ">
                        {{ box3Title }}</h3>
                    <div class="d-flex p-2 justify-content-center"><div class="small-city-green-div"></div></div>
                    <p class="white-font mbr-fonts-style display-7 ">
                        {{ box3Detail }}<br></p>
                    <a class="btn btn-sm btn-white display-4 " v-bind:href="box3Link">
                        {{ box3Button }}
                    </a> 
                </div>
            </div>
        </div>
    </div>
    <div id="jarallax-container-1" class="blue-water-style">
        
    <div id="city-blue-water"></div>
    </div>
</section>

<!-- Map -->
<section class="city-green-color">
  <div class="row">
        <div class="col esri-section">
            <iframe title="Wastewater Mains Map" class="esri-map z400" height="500" frameborder="0" scrolling="no" allowfullscreen src="https://corpus.maps.arcgis.com/apps/Embed/index.html?webmap=72c409562d7740989912fc6dd29b2fad&extent=-97.5449,27.6856,-97.2914,27.8401&home=true&zoom=true&previewImage=false&scale=true&legend=true&disable_scroll=true&theme=light">
            </iframe>
        </div>
        <div class="col" id="mapbox">
                <h2 class="city-green-mt mbr-section-title pb-3 mbr-fonts-style display-2 ">
                {{ titleMains }}</h2>
                <p class="">{{ subhead }}</p>
                
                <div class="mbr-section-btn ">
                    <a class="btn btn-md btn-success display-4" href="https://corpus.maps.arcgis.com/apps/Embed/index.html?webmap=72c409562d7740989912fc6dd29b2fad&extent=-97.5449,27.6856,-97.2914,27.8401&home=true&zoom=true&previewImage=false&scale=true&legend=true&disable_scroll=true&theme=light">{{ mapLinkOne }}</a>
                    <a class="btn btn-md btn-white display-4 " href="https://corpus.maps.arcgis.com/apps/Embed/index.html?webmap=ca3da6d39e8f48869c79ea10e00649ed&extent=-97.6879,27.5914,-97.1808,27.9004&home=true&zoom=true&previewImage=false&scale=true&legend=true&disable_scroll=true&theme=light">
                     {{ mapLinkTwo }}
                    </a> 
                </div>
        </div>
    </div>
</section>


<section class="city-stats" id="features3-a" data-rv-view="363" data-jarallax-original-styles="null">
    <div class="container">
        <div class="media-container-row">

            <div data-aos="zoom-in" class="card p-3 col-12 col-md-6 col-lg-4">
                <div>
                    <div class="card-box">
                        <h3 class="city-stat-text card-title mbr-fonts-style display-5">
                            <span class="city-stat-number">15</span>
                            Years</h3>
                            <div class="d-flex p-2 justify-content-center"><div class="city-green-div"></div></div>
                        <p class="city-sub-font display-7">
                            Of improvements and upgrades<br></p>
                    </div>
                </div>
            </div>



            <div data-aos="zoom-in" class="card p-3 col-12 col-md-6 col-lg-4">
                <div>
                    <div class="card-box">
                        <h3 class="city-stat-text card-title mbr-fonts-style display-5">
                            <span class="city-stat-number">92%</span>
                        </h3>
                        <div class="d-flex p-2 justify-content-center"><div class="city-green-div"></div></div>
                        <p class="city-sub-font display-7">
                           Reduction in sanitary sewer overflows since 2012
                        </p>
                    </div>
                    
                </div>
            </div>

            <div data-aos="zoom-in" class="card p-3 col-12 col-md-6 col-lg-4">
                <div>
                    <div class="card-box">
                        <h3 class="city-stat-text card-title mbr-fonts-style display-5">
                            <span class="city-stat-number">325k</span>
                        </h3>
                            <div class="d-flex p-2 justify-content-center"><div class="city-green-div"></div></div>
                        <p class="city-sub-font display-7">
                           Customers served
                        </p>
                    </div>
                    
                </div>
            </div>

        </div>
    </div>
</section>


</div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      title: 'Clean Bays Blueprint',
      subheading: 'Designing solutions to protect our water.',
      link1Title: 'News',
      link1Html: './news.html',
      link2Title: 'Project FAQs',
      link2Html: './faqs.html',
      box1Title: 'About Clean Bays Blueprint',
      box1Detail: 'Learn more about how Corpus Christi is keeping our bays clean.',
      box1Button: 'About the Bays',
      box1Link: './about.html',
      box2Title: 'Investing in Corpus Christi',
      box2Detail: 'Understand how long-term investments in our infrastructure build better futures.',
      box2Button: 'Our Goals',
      box2Link: './invest.html',
      box3Title: 'Doing your part',
      box3Detail: 'Help us keep our bay beautiful for generations to come.',
      box3Button: 'You Can Help',
      box3Link: './doing.html',
      titleMains: 'Explore Wastewater Mains',
      subhead: "This feature is a digital representation of Corpus Christi's waste water mains infrastructure.",
      mapLinkOne:'Blueprint Map',
      mapLinkTwo:'Standard Map'
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Home.vue